import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-green-200 to-green-400 dark:from-green-700 dark:to-green-900 text-gray-900 dark:text-green-200 py-4">
      <div className="max-w-7xl mx-auto px-4 text-center text-sm">
        <p>© 2025 Gifted Solutions.</p>
        <p className="mt-1">Developed by Bupe Nondo</p>
      </div>
    </footer>
  );
};

export default Footer;
